import { createI18n } from 'vue-i18n';
import { i18nOptions } from './i18n-options';

export const i18n = createI18n(i18nOptions);

export { safeTranslatePlugin } from './i18n-safe-translate';
